// Puzzle generation and solving logic
// Uses backtracking for generation and solving

// Helper to check if a number can be placed
function isSafe(grid, row, col, num) {
  // Check row
  for (let x = 0; x < 9; x++) if (grid[row][x] === num) return false;
  // Check col
  for (let x = 0; x < 9; x++) if (grid[x][col] === num) return false;
  // Check box
  const startRow = row - row % 3;
  const startCol = col - col % 3;
  for (let i = 0; i < 3; i++)
    for (let j = 0; j < 3; j++)
      if (grid[i + startRow][j + startCol] === num) return false;
  return true;
}

// Solve the puzzle (backtracking)
function solve(grid) {
  for (let row = 0; row < 9; row++) {
    for (let col = 0; col < 9; col++) {
      if (grid[row][col] === 0) {
        for (let num = 1; num <= 9; num++) {
          if (isSafe(grid, row, col, num)) {
            grid[row][col] = num;
            if (solve(grid)) return true;
            grid[row][col] = 0;
          }
        }
        return false;
      }
    }
  }
  return true;
}

// Generate full solved board
function generateFullBoard(rng = Math.random) {
  const grid = Array(9).fill().map(() => Array(9).fill(0));
  // Fill diagonally to ensure solvability. The shuffle must happen ONCE,
  // outside the loop: reshuffling per-cell (as the original prototype did)
  // can place duplicate values in the same 3x3 box, making the grid
  // unsolvable and causing solve() to backtrack exhaustively trying to
  // prove that. Surfaced by seeded generation, where a bad seed reproduces
  // the same unsolvable diagonal (and multi-minute hang) every time.
  const nums = [1,2,3,4,5,6,7,8,9].sort(() => rng() - 0.5);
  for (let i = 0; i < 9; i++) {
    grid[i][i] = nums[i];
  }
  solve(grid); // Fill the rest
  return grid;
}

// Generate puzzle with given clues count (higher = easier)
function generatePuzzle(clues, rng = Math.random) {
  const full = generateFullBoard(rng);
  const puzzle = full.map(row => row.slice());
  const placed = [];
  // Remove numbers until we have 'clues' left
  while (puzzle.flat().filter(n => n !== 0).length > clues) {
    const row = Math.floor(rng() * 9);
    const col = Math.floor(rng() * 9);
    if (puzzle[row][col] !== 0) {
      placed.push([row, col, puzzle[row][col]]);
      puzzle[row][col] = 0;
    }
  }
  return { puzzle, solution: full, id: Date.now() + Math.random() }; // Unique ID
}

// Levels: clues count
const LEVELS = {
  easy: 50,
  medium: 40,
  hard: 32,
  evil: 28,
  nightmare: 22
};

export { generatePuzzle, solve, LEVELS };
